import type { UiError } from "../errors/uiError";

/**
 * What the web app knows about the DMW server, from its last readiness check
 * (`GET /health/ready`). Each check replaces the previous result, so any status can follow
 * any other; the union only fixes which statuses exist and what each carries.
 */
export type ServerConnection =
  | { readonly status: "checking" }
  | { readonly status: "connected" }
  /** The server answers, but cannot reach its database. */
  | { readonly status: "databaseUnavailable" }
  /** No answer from the server. */
  | { readonly status: "unreachable" }
  /** The server answered in a way the app cannot interpret. */
  | { readonly status: "faulty"; readonly error: UiError };

export type ServerConnectionStatus = ServerConnection["status"];

const DATABASE_UNAVAILABLE_CODE = "dependency_unavailable";

export function connectionAfterFailedReadinessCheck(error: UiError): ServerConnection {
  if (error.kind === "serverUnreachable") {
    return { status: "unreachable" };
  }
  if (error.kind === "problem" && error.problem.code === DATABASE_UNAVAILABLE_CODE) {
    return { status: "databaseUnavailable" };
  }
  return { status: "faulty", error };
}
